import { styled } from '@/styled-system/jsx';
import { css } from '@/styled-system/css';

// Grid layout styles
export const photoGalleryGrid = css({
  position: 'relative',
  display: 'grid',
  gap: '1x',
  gridAutoColumns: '1fr',
  width: '100%',
  margin: '0px',
  padding: '0px',
  maxHeight: 'none !important',
});

export const largeTile = css({
  gridColumn: { base: '', md: 'span 2' },
  height: { base: '286px', sm: '300px', md: '606px', lg: '606px', xl: '606px', xxl: '606px' },
});

export const smallTile = css({
  height: { base: '286px', sm: '300px', md: '300px', lg: '300px', xl: '300px', xxl: '300px' },
});

// Main container
export const PhotoGalleryPopupModalContainer = styled('div', {
  base: {
    md: {
      position: 'relative',
      height: '80vh',
      width: '768px',
    },
    lg: {
      position: 'relative',
      height: '80vh',
      width: '974px',
    },
  },
});

// Header styles - using existing PhotoGalleryHeader component

export const PhotoGalleryPopupModalHeaderLeft = styled('div', {
  base: {
    paddingLeft: '2x',
    height: '100%',
    width: '50%',
  },
});

export const PhotoGalleryPopupModalHeaderRight = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingRight: '1x',
    width: '50%',
    height: '100%',
  },
});

export const PhotoGalleryPopupModalBackBtn = styled('button', {
  base: {
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
  },
});

export const PhotoGalleryPopupModalArrow = styled('img', {
  base: {
    width: '2x',
    height: '2x',
  },
});

export const PhotoGalleryPopupModalBack = styled('div', {
  base: {
    paddingTop: '2px',
    paddingLeft: 'xs',
  },
});

// Content area
export const PhotoGalleryPopupModalContent = styled('div', {
  base: {
    paddingLeft: '1x',
    paddingRight: '1x',
    paddingBottom: '56px',
    position: 'absolute',
    top: '40px',
    bottom: '0',
    overflowY: 'auto',
    width: '100%',
    height: 'calc(100% - 108px)',
    md: {
      position: 'absolute',
      paddingLeft: '4x',
      paddingRight: '18px',
      marginTop: '6x',
      top: '0',
      overflowY: 'scroll',
      height: 'calc(100% - 120px)',
    },
  },
});

// Footer styles
export const PhotoGalleryPopupModalButtons = styled('div', {
  base: {
    display: 'flex',
    justifyContent: 'end',
  },
});

export const PhotoGalleryPopupModalFooter = styled('div', {
  base: {
    backgroundColor: 'hpxWhite',
    position: 'fixed',
    display: 'flex',
    justifyContent: 'space-between',
    paddingTop: '16px',
    paddingRight: '24px',
    paddingBottom: '16px',
    paddingLeft: '8px',
    bottom: '0',
    width: '100%',
    md: {
      paddingTop: '16px',
      paddingRight: '32px',
      paddingBottom: '16px',
      paddingLeft: '32px',
    },
  },
});

// Button styles
export const PhotoGalleryPopupModal3dBtn = styled('div', {
  base: {
    display: 'none',
    marginRight: '1x',
    md: {
      display: 'inline-block',
    },
  },
});

export const PhotoGalleryPopupModal3dIcon = styled('img', {
  base: {
    width: '2x',
    height: '2x',
    marginRight: '1x',
  },
});

export const PhotoGalleryPopupModal3dMwebBtn = styled('div', {
  base: {
    md: {
      display: 'none',
    },
  },
});

// Title styles
export const PhotoGalleryPopupModalTitle = styled('div', {
  base: {
    textAlign: 'left',
    fontSize: 'lg',
    paddingTop: '16px',
    paddingRight: '8px',
    paddingBottom: '8px',
    paddingLeft: '8px',
    md: {
      paddingTop: '8px',
      paddingRight: '0',
      paddingBottom: '8px',
      paddingLeft: '0',
    },
  },
});

export const StyledTitleDiv = styled('div', {
  base: {
    paddingTop: '4x',
  },
});
